import axios from "axios";

import { ScenarioField } from "components/stick-data-management/types/field";
import { StickFieldsTemplate } from "components/stick-data-management/types/template";

const projectServiceEndpoint = process.env.REACT_APP_PROJECT_SERVICE;

export interface UpdateStickFieldTemplateRequest {
  name?: string;
  fields?: ScenarioField[];
}

export const stickFieldTemplatesApi = {
  async getByProject(projectId: string): Promise<StickFieldsTemplate[]> {
    const res = await axios.get(
      `${projectServiceEndpoint}/stick-fields-templates/${projectId}`
    );
    return res.data ?? [];
  },

  async create(data: {
    projectId: string;
    name: string;
    fields: ScenarioField[];
  }): Promise<StickFieldsTemplate> {
    const res = await axios.post(
      `${projectServiceEndpoint}/stick-fields-templates`,
      data
    );
    return res.data;
  },

  async update(id: string, data: UpdateStickFieldTemplateRequest): Promise<void> {
    await axios.put(`${projectServiceEndpoint}/stick-fields-templates/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    await axios.delete(`${projectServiceEndpoint}/stick-fields-templates/${id}`);
  }
};
